module.exports = __webpack_public_path__ + "static/img/overseas-1.39d2094.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/overseas-1.png
// module id = /zDF
// module chunks = 1